import { parseUtcDateTime } from './parseUtcDateTime';

const DAY = 24 * 60 * 60;

// [unit, threshold to pick it, seconds per unit] — months only take over from
// two months up, so a 5-week-old version reads "5 weeks ago", not "1 month ago"
const UNITS: [Intl.RelativeTimeFormatUnit, number, number][] = [
  ['year', 365 * DAY, 365 * DAY],
  ['month', 60 * DAY, 30 * DAY],
  ['week', 7 * DAY, 7 * DAY],
  ['day', DAY, DAY],
  ['hour', 60 * 60, 60 * 60],
  ['minute', 60, 60],
];

// "3 days ago" / "5 weeks ago" for a past date; anything under a minute
// (or in the future, e.g. client clock behind the server) reads "just now".
export const formatRelativeTime = (date: string): string => {
  const seconds = Math.round((Date.now() - parseUtcDateTime(date).getTime()) / 1000);

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'always' });
  for (const [unit, threshold, unitSeconds] of UNITS) {
    if (seconds >= threshold) {
      return rtf.format(-Math.floor(seconds / unitSeconds), unit);
    }
  }

  return 'just now';
};
